import MojitoServices from 'mojito/services';
import { useSelector } from 'react-redux';

const { selectors: messagingSelectors } = MojitoServices.Messaging;
const { selectToastMessages } = messagingSelectors;

/**
 * Contains custom hooks for player toast message functionality.
 *
 * @class ToastMessageHooks
 * @name hooks
 * @memberof Mojito.Modules.PlayerMessages
 */

/**
 * Hook listens for {@link MojitoServices.Messaging.store|MessagingStore} changes
 * and returns first available toast {@link Mojito.Services.Messaging.types.Message|Message} object by `type`.
 *
 * @function useToastMessage
 *
 * @param {string} type - The type of the toast message that will be requested from the store.
 * @returns {Mojito.Services.Messaging.types.Message} Message object.
 * @memberof Mojito.Modules.PlayerMessages.hooks
 */
const useToastMessage = type => {
    return useSelector(state => selectToastMessages(state).find(message => message.type === type));
};

export { useToastMessage };
